
<button matIconButton type="button" class="close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<h4 mat-dialog-title class="box">{{ 'send-remark.title' | translate }}</h4>
@if (!msgIsSent && !errorIsSent) {
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)" class="form">
    <mat-dialog-content class="mat-typography">
      <mat-form-field  appearance="outline" class="form-element">
        <mat-label>{{ 'general.form.firstname.placeholder' | translate }}</mat-label>
        <input matInput type="txt" name="firstName"  formControlName="firstName">
        @if (!firstName.valid && firstName.touched) {
          <mat-error>
            {{'general.validation.maxlength'|translate}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field  appearance="outline" class="form-element">
        <mat-label>{{ 'general.form.lastname.placeholder' | translate }}</mat-label>
        <input matInput type="txt" name="LastName"  formControlName="lastName">
        @if (!lastName.valid && lastName.touched) {
          <mat-error>
            {{'general.validation.maxlength'|translate}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field  appearance="outline" class="form-element">
        <mat-label>{{ 'general.form.email.placeholder' | translate }}</mat-label>
        <input matInput type="email" name="email"  formControlName="email">
        @if (!formGroup.controls['email'].valid && formGroup.controls['email'].touched) {
          <mat-error>
            {{ getErrorEmail() |translate}}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field  appearance="outline" class="form-element">
        <mat-label>{{ 'send-remark.form.message.placeholder' | translate }}</mat-label>
        <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="12" matInput formControlName="message"></textarea>
        @if (!formGroup.controls['message'].valid && formGroup.controls['message'].touched) {
          <mat-error>
            {{ getErrorMessage() | translate }}
          </mat-error>
        }
      </mat-form-field>
      <!-- images upload -->
      <h5>{{ 'send-remark.form.add-pictures' | translate }} </h5>
      <div  @fade class="file-upload-container">
        <tt-file-uploader #fileUploader [multiple]="true" [showFileList]="true" [maxFilesToUpload]="3"
        [accept]="allowedMIMETypes.toString()" [allowedExtensions]="allowedExtensions" [capturesEnabled]="true"></tt-file-uploader>
      </div>

        <div class="mt-1">
          <mat-checkbox formControlName="keepInformed" value="0">{{ 'send-remark.form.keep-me-informed' |
            translate }}
          </mat-checkbox>
        </div>
        <div class="copyright-txt" style="padding: 16px 0 2px 4px; text-align: center;">
          <a style="margin: 0 !important;" href="{{ 'general.terms_of_use_url' | translate }}" target="_blank">{{ "general.terms_of_use_agree" | translate }}</a>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="">
        <div class="button-container">
          <button mat-flat-button 
            [disabled]="!formGroup.valid || (fileUploader && fileUploader.filesContainErrors()) || loading" type="submit">
            <!-- keep the icon separated from the label, otherwise the button renders bad -->
            @if (!loading || (!fileUploader)) {
              <mat-icon aria-label="map">send</mat-icon>
            } 
            @if (!loading || (!fileUploader)) {
              &nbsp;&nbsp;{{"send-remark.button.send"|translate}}
            }
            @if (loading && (fileUploader && fileUploader.getFiles().length > 0)) {
              <mat-icon aria-label="map">upload</mat-icon>
            }
            @if (loading && (fileUploader && fileUploader.getFiles().length > 0)) {
              &nbsp;&nbsp;{{("send-remark.upload-status." + uploadStatus.toLowerCase())|translate}}
            }
            <span> &nbsp;
              @if (loading && !fileUploader) {
                <mat-spinner style="float: right;margin-top:10px"  diameter=20></mat-spinner>
              }
            </span>
            @if (loading && (fileUploader && fileUploader.getFiles().length > 0)) {
              <mat-progress-bar style="bottom: 7px;" [color]="'accent'" [value]="uploadProgress" [mode]="progressbarMode">
              </mat-progress-bar>
            }
          </button>
        </div>
        <div class="button-container">
          <a mat-button mat-dialog-close class="back-tip"><mat-icon aria-label="map">arrow_back_ios</mat-icon>{{"send-remark.link.back"|translate}}</a>         
        </div>
      </mat-dialog-actions>
    </form>
  }



  <!-- succes msg -->
  @if (msgIsSent) {
    <mat-dialog-content class="mat-typography">
      <br>
        <mat-icon style="color:#068a9b;display:contents">done</mat-icon> {{'send-remark.mail.sent'|translate}}
        <br>
          {{error}}
        </mat-dialog-content>
      }
      @if (msgIsSent) {
        <mat-dialog-actions align="center" class="">
          <div class="button-container">
            <a mat-button mat-dialog-close class="close-tip">&nbsp;{{"general.close"|translate}}</a>
          </div>
        </mat-dialog-actions>
      }



      <!-- error msg -->
      @if (errorIsSent) {
        <mat-dialog-content class="mat-typography error-txt">
          <br>
            {{'send-remark.mail.error'|translate}}
            <br>
              {{error}}
            </mat-dialog-content>
          }
          @if (errorIsSent) {
            <mat-dialog-actions align="center" class="">
              <div class="button-container">
                <a mat-button mat-dialog-close class="close-tip">&nbsp;{{"general.close"|translate}}</a>
              </div>
            </mat-dialog-actions>
          }